// Forms widget helper functions and data
import { widgetInitialData } from "../widgets.helpers";
import { FormsDrawers } from "./widgets.forms.types";

const drawers: FormsDrawers = {};

export const formsInitialData = { ...widgetInitialData, drawers };
